import { Extension } from '@tiptap/core';

const SingleLine = Extension.create({
  addKeyboardShortcuts(this) {
    return {
      Enter: () => true,
      'Shift-Enter': () => true,
      'Mod-Enter': () => true,
    };
  },
});

export { SingleLine };
